import React from 'react';
import PropTypes from 'prop-types';
import * as handlebars from 'handlebars';
import { X, BarChart3 } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';

function StatisticDialog({ isOpen, onClose, template, reviewStatistic }) {
  if (!isOpen) return null;

  // eslint-disable-next-line func-names
  handlebars.registerHelper('ifEquals', function (arg1, arg2, option) {
    return arg1 === arg2 ? option.fn(this) : option.inverse(this);
  });

  const hbs = handlebars.compile(template.trim().replaceAll('\\n', ''));
  const result = hbs(reviewStatistic);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div
        className="relative bg-background rounded-lg shadow-lg w-full max-w-3xl mx-4 max-h-[80vh] overflow-hidden"
        style={{ border: '1px solid hsl(var(--border))' }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-4 border-b"
          style={{ borderColor: 'hsl(var(--border))' }}
        >
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <BarChart3 className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Review Statistics</h2>
              <p className="text-sm text-muted-foreground">Detailed breakdown of review metrics</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-4 overflow-y-auto max-h-[60vh]">
          {/* eslint-disable react/no-danger */}
          <div
            className="prose prose-sm dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: result }}
          />
        </div>

        {/* Footer */}
        <div
          className="flex justify-end px-6 py-4 border-t"
          style={{ borderColor: 'hsl(var(--border))' }}
        >
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </div>
  );
}

StatisticDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  template: PropTypes.string.isRequired,
  reviewStatistic: PropTypes.shape({}).isRequired,
};

export default StatisticDialog;
